'use client';

import { Button } from '@/components/ui/button';
import { client } from '@/lib/client';
import { safeStringify } from '@/lib/utils';
import Link from 'next/link';
import { useEffect } from 'react';

export default function ErrorPage({
	error,
	reset
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		if (error) {
			client.post('/report-errors', {
				errorMessage: error.message,
				error: safeStringify(error)
			});
		}
	}, [error]);

	return (
		<div>
			<section className='bg-app-background-color min-h-screen py-3'>
				<div className='mx-auto max-w-screen-xl px-4 py-8 md:py-16 lg:px-6 lg:py-32'>
					<div className='mx-auto max-w-screen-sm text-center'>
						<h1 className='mb-4 text-7xl font-extrabold tracking-tight text-app-foreground-color lg:text-9xl'>400</h1>

						<p className='mb-4 text-3xl font-bold tracking-tight text-app-foreground-color'>{'Đã có lỗi xảy ra'}</p>

						<p className='mb-4 text-lg font-light text-app-foreground-color'>
							Bạn có thể liên hệ với chúng tôi để khắc phục nhanh chóng.
						</p>

						<div className='mt-4 space-x-2'>
							<Button className='bg-app-primary-color hover:bg-app-primary-color hover:opacity-90'>
								<Link href={'/'}>Trở lại trang chủ</Link>
							</Button>

							<Button onClick={reset} className='bg-app-primary-color hover:bg-app-primary-color hover:opacity-90'>
								Thử lại
							</Button>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
